export const PUBLIC_ROUTES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/access-denied',
] as const;

export const ALWAYS_ALLOWED_ROUTES = [
  '/',
  '/dashboard',
  '/permissions',
  '/permissions-management',
  '/all-services',
  '/all-resources',
  // Self-servis affiliate paneli: admin izniyle değil, "bu hesabın affiliate
  // profili var mı" kontrolüyle kapılanıyor (bkz. AffiliateDashboard sayfası).
  // /affiliates ve /affiliate-commissions (admin ekranları) bilerek burada
  // değil — onlar backend page-routes/permission sistemiyle gated kalmalı.
  '/affiliate-dashboard',
] as const;

export type PublicRoutes = (typeof PUBLIC_ROUTES)[number];
export type AlwaysAllowedRoutes = (typeof ALWAYS_ALLOWED_ROUTES)[number];
